import { Component, Inject, OnInit, AfterViewInit, ViewChild, ElementRef } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Subscription, timer } from 'rxjs';

@Component({
  selector: 'app-modal-general',
  templateUrl: './modal-general.component.html',
  styleUrls: ['./modal-general.component.scss']
})
export class ModalGeneralComponent implements OnInit, AfterViewInit {
  @ViewChild('htmlDiv') htmlDiv!: ElementRef<HTMLDivElement>;

  html: string;
  title: string;
  tipografy: string;
  tipografyTitle: string;

  private scrollSub?: Subscription;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: { html: string; title: string, tipografy?: string, tipografyTitle?: string },
    private dialogRef: MatDialogRef<ModalGeneralComponent>
  ) {
    this.html = data.html;
    this.title = data.title;
    if (data.tipografy) this.tipografy = data.tipografy;
    if (data.tipografyTitle) this.tipografyTitle = data.tipografyTitle;
  }

  ngOnInit(): void {}

  ngAfterViewInit(): void {
    this.resetScrollReactive();
  }

  private resetScrollReactive() {
    // Esperamos un tick para asegurarnos que el contenido esté renderizado
    timer(0).subscribe(() => {
      const dialogContent = this.htmlDiv?.nativeElement.parentElement?.parentElement as HTMLElement;
      if (dialogContent) {
        dialogContent.scrollTop = 0;
      }
    });
  }

  // Si quieres actualizar HTML dinámicamente y mantener scroll al inicio
  setHtml(newHtml: string) {
    this.html = newHtml;
    this.resetScrollReactive();
  }
}
